import { Signal } from "@preact/signals";
import { WorkflowResults } from "../state/types";
import { WorkflowCell } from "./WorkflowCell";

type Props = {
  results: Signal<WorkflowResults>;
};

export function WorkflowColumn(props: Props) {
  return props.results.value.map(p => {
    return <WorkflowCell {...p}></WorkflowCell>;
  });
}
